import { Stack } from "@mui/material";
import type { PropsWithChildren } from "react";
import ArtifactAgentAvatar from "./ArtifactAgentAvatar";

const ArtifactAgentReply = ({ children }: PropsWithChildren) => (
  <Stack direction="row" spacing={1.25} sx={{ alignItems: "flex-start" }}>
    <ArtifactAgentAvatar size="small" />
    <Stack spacing={1} sx={{ flex: 1, minWidth: 0, pt: 0.25 }}>
      {children}
    </Stack>
  </Stack>
);

export default ArtifactAgentReply;
